import * as React from 'react';
import { Facet, RefinementType, FacetFilterValue, FacetFilter, Refinements, FacetValue } from '@packages/common';
import { RefinementsContext } from '../RefinementsContext';
import { useRefinements } from './useRefinements';
import { facetFilter$ } from './refinementsEvents';

function sanitizeFacetFilterValue({
  isHero,
  name,
  seoName,
  featureValue,
}: FacetValue | FacetFilterValue): FacetFilterValue {
  return {
    isHero,
    name,
    seoName,
    featureValue,
  };
}

export const useFacetFilters = (facet: Facet) => {
  const { refinements } = React.useContext(RefinementsContext);
  const { updateFacetFilters } = useRefinements();
  const facetFilters = refinements[RefinementType.FACET_FILTERS];
  const currentRefinements = facetFilters[facet.featureMapping] ? facetFilters[facet.featureMapping].values : [];
  const currentValues = facetFilters?.[facet.featureMapping]?.values ?? [];

  const isSelected = React.useCallback(
    (item: FacetFilterValue) => {
      return currentValues.filter((value: any) => value.seoName === item.seoName).length > 0;
    },
    [currentValues],
  );

  const toggle = React.useCallback(
    (item: FacetFilterValue | FacetValue) => () => {
      const updatedFilter: FacetFilter = {
        ...facetFilters[facet.featureMapping],
        seoName: facet.seoName,
        relation: facet.relation,
        values: isSelected(item)
          ? [...currentValues.filter((value: any) => value.seoName !== item.seoName)]
          : [...currentValues, sanitizeFacetFilterValue(item)],
      };
      const updatedFacetFilters: Refinements[RefinementType.FACET_FILTERS] = {
        ...facetFilters,
        [facet.featureMapping]: updatedFilter,
      };

      updateFacetFilters(updatedFacetFilters);
      facetFilter$.next({ isActive: !isSelected(item), valueSeoName: item.seoName, facetSeoName: facet.seoName });
    },
    [currentValues, facet, isSelected, facetFilters, updateFacetFilters],
  );

  return { toggle, isSelected, currentRefinements };
};
